import { Bell, ThumbsUp, ClipboardCheck, Calendar } from 'lucide-react';

export const getNotifIcon = (type) => {
  switch (type) {
    case 'client_decision': return <ThumbsUp className="h-4 w-4" />;
    case 'evaluation_completed': return <ClipboardCheck className="h-4 w-4" />;
    case 'meeting_scheduled': return <Calendar className="h-4 w-4" />;
    default: return <Bell className="h-4 w-4" />;
  }
};

export const getNotifColor = (type, decision) => {
  if (type === 'client_decision') {
    return decision === 'interested' 
      ? 'bg-green-100 text-green-600' 
      : 'bg-red-100 text-red-600';
  }
  if (type === 'evaluation_completed') return 'bg-blue-100 text-blue-600';
  if (type === 'meeting_scheduled') return 'bg-purple-100 text-purple-600';
  return 'bg-gray-100 text-gray-600';
};

export const formatTimeAgo = (dateStr) => {
  if (!dateStr) return '';
  const date = new Date(dateStr);
  const now = new Date();
  const diff = Math.floor((now - date) / 1000);
  if (diff < 60) return 'maintenant';
  if (diff < 3600) return `il y a ${Math.floor(diff / 60)}min`;
  if (diff < 86400) return `il y a ${Math.floor(diff / 3600)}h`;
  return `il y a ${Math.floor(diff / 86400)}j`;
};
